







































import { ObjectFactory } from '@/config/objectFactory';
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';
import { ApiRequest } from '@/types/request';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';


@Component({
    mixins: [validationMixin],
    props: {
        transportId: String,
    },
    data() {
        return {
            vehiclesExcel: {
                file: FormData,
                filename: '',
            },
        };
    },
    validations: {
        vehiclesExcel: {
            filename: {
                required,
            },
        },
    },
})
export default class UploadVehiclesModal extends Vue {
    private show = true;

    private async setExcel($event: any) {
        const filename = $event.target.files[0].name.toLowerCase();
        if (filename.endsWith('.xlsx')) {
            this.$data.vehiclesExcel.file = $event.target.files[0];
            this.$data.vehiclesExcel.filename = $event.target.files[0].name;
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be xlsx',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = 'file-input-1';
            const element = this.$refs[inputName] as any;
            element.reset();
        }
    }

    private async uploadVehicles() {
        const excelFormData = new FormData();
        excelFormData.append('file', this.$data.vehiclesExcel.file);
        excelFormData.append('transporterId', this.$props.transportId);
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_VEHICLE}/vehicles/upload`,
            data: excelFormData,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Vehicles uploaded successfully',
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$emit('success');
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$emit('close');
    }
}
